// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_1_oaAoknc26-EWkTFpKjfx"};